import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actions from "../../actions";
import LayoutContainer from "../Layout";
import { CssBaseline } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { theme } from "@answersnow/pkg-theme";
import LuxonUtils from "@date-io/luxon";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import enUsLocale from "date-fns/locale/en-US";
import esLocale from "date-fns/locale/es";
import { useTranslation } from "react-i18next";
import { QueryClient, QueryClientProvider } from "react-query";

import { LicenseInfo } from "@mui/x-license";
import { jam } from "@jam.dev/sdk";
import { getSignedinState } from "selectors";

// Create a QueryClient instance
const queryClient = new QueryClient();

const DATE_FNS_LOCALES = { en: enUsLocale, es: esLocale };

const LocalizedPickerProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const adapterLocale = DATE_FNS_LOCALES[i18n.language?.split("-")[0]] || enUsLocale;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={adapterLocale} utils={LuxonUtils}>
      {children}
    </LocalizationProvider>
  );
};

const mapStateToProps = (state) => ({
  signedInState: getSignedinState(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      systemLoaded: actions.systemLoaded,
      checkAuthState: actions.checkAuthState,
    },
    dispatch
  );

export class App extends Component {
  componentDidMount() {
    this.props.systemLoaded();
    this.props.checkAuthState();
    LicenseInfo.setLicenseKey(process.env.MUI_X_LICENSE_KEY);
    window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;

    // set up Jam metadata hook
    if (process.env.NODE_ENV !== "production") {
      import("hooks/useJamMetadata").then(({ useJamMetadata }) => {
        const [jamMetadata] = useJamMetadata();
        jam.metadata(() => jamMetadata);
      });
    }
  }

  render() {
    return (
      <QueryClientProvider client={queryClient}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <LocalizedPickerProvider>
              <CssBaseline />
              <div style={{ minWidth: 300, height: "100%" }}>
                <LayoutContainer {...this.props} />
              </div>
            </LocalizedPickerProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </QueryClientProvider>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
